import type { Props } from './Svg'

export function CrossBigIcon(props: Props) {
  return (
    <svg width="79" height="79" fill="none" {...props}>
      <path
        d="M40.125 69.25c16.361 0 29.625-13.264 29.625-29.625S56.486 10 40.125 10 10.5 23.264 10.5 39.625 23.764 69.25 40.125 69.25Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M47.914 33.414 46.5 32l-6.293 6.293L33.914 32 32.5 33.414l6.293 6.293L32.5 46l1.414 1.414 6.293-6.293 6.293 6.293L47.914 46l-6.293-6.293 6.293-6.293Z"
        fill="currentColor"
      />
    </svg>
  )
}
